<template>
	<div class="text-justify">
		<div class="content-wrapper">
			<app-overlay-loader v-if="preloader" />
			<parent-interview-tab-booking-table :value="this.value"></parent-interview-tab-booking-table>
		</div>
	</div>
</template>

<script>
import { BookingFormMixin } from "./BookingFormMixin";
import GlobalHelperMixin from "../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	mixins: [BookingFormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
		};
	},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 40px;
}
/* .form-control {
	border: 3px solid;
} */
.required-star {
	color: red;
}
</style>
